import React from "react";
import { FormattedMessage } from "react-intl";

import * as Yup from "yup";

export const yupObjectValidation = {
  name1: Yup.string()
    .matches(/^[A-Za-z ]*$/, () => <FormattedMessage id="VALID_NAME_YUP" />)
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(70, <FormattedMessage id="YUP.MAXIMUM_70" />)
    .required(<FormattedMessage id="YUP_NAME_REQUIRED" />),
  name2: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="YUP_LOGISTIC_TYPE_REQUIRED" />),
  name3: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required(
        <FormattedMessage id="YUP_NAME_REQUIRED" />,
      ),
    }),
  ),
  name4: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(70, <FormattedMessage id="YUP.MAXIMUM_70" />)
    .required(<FormattedMessage id="YUP_NAME_IS_REQUIRED" />),
  password: Yup.string()
    .min(8, <FormattedMessage id="YUP.MINIMUM_8" />)
    .max(20, <FormattedMessage id="YUP.MAXIMUM_20" />)
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$/,
      () => <FormattedMessage id="YUP_PASSWORD_PATTERN" />,
    )
    .required(<FormattedMessage id="YUP_PASSWORD_REQUIRED" />),
  email1: Yup.string()
    .email(<FormattedMessage id="YUP_WRONG_EMAIL_ID" />)
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(255, <FormattedMessage id="YUP.MAXIMUM_255" />)
    .required(<FormattedMessage id="YUP_EMAIL_REQUIRED" />),
  email2: Yup.string()
    .email(<FormattedMessage id="YUP_WRONG_EMAIL_ID" />)
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="YUP_COMPANY_EMAIL_REQUIRED" />),
  email3: Yup.string().required(<FormattedMessage id="YUP_EMAIL_REQUIRED" />),
  phone1: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      () => <FormattedMessage id="YUP_VALID_NUMBER" />,
    )
    .min(10, <FormattedMessage id="YUP.MINIMUM_10" />)
    .max(11, <FormattedMessage id="YUP.MAXIMUM_11" />)
    .required(<FormattedMessage id="YUP_MOBILE_REQUIRED" />),
  phone2: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      () => <FormattedMessage id="YUP_VALID_NUMBER" />,
    )
    .min(10, <FormattedMessage id="YUP.MINIMUM_10" />)
    .max(11, <FormattedMessage id="YUP.MAXIMUM_11" />)
    .required(<FormattedMessage id="YUP_PHONE_NUMBER_REQUIRED" />),
  phone3: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      () => <FormattedMessage id="YUP_PASSWORD_PATTERN" />,
    )
    .min(10, <FormattedMessage id="YUP.MINIMUM_10" />)
    .max(11, <FormattedMessage id="YUP.MAXIMUM_11" />)
    .required(<FormattedMessage id="YUP_MOBILE_REQUIRED" />),
  change_password: Yup.string()
    .required(<FormattedMessage id="YUP_CONFIRM_PASSWORD_REQUIRED" />)
    .when("password", {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf(
        [Yup.ref("password")],
        <FormattedMessage id="YUP_PASSWORD_NOT_MATCH" />,
      ),
    }),
  year: Yup.string()
    .matches(/^[0-9\b]+$/, () => <FormattedMessage id="YUP_DIGIT_ONLY" />)
    .min(1, <FormattedMessage id="YUP.MINIMUM_1" />)
    .max(4, <FormattedMessage id="YUP.MAXIMUM_4" />)
    .required(<FormattedMessage id="YUP_YEAR_REQUIRED" />),
  company_name1: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="COMPANY_NAME_REQUIRED" />),
  company_name: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />),
  company_name2: Yup.string()
    .matches(
      /^[ A-Za-z0-9&()_#/,\.-]*$/,
      () => <FormattedMessage id="GLOBAL.COMPANY_NAME_REGEX" />,
    )
    .max(255, <FormattedMessage id="YUP.MAXIMUM_255" />)
    .required(<FormattedMessage id="COMPANY_NAME_REQUIRED" />),
  company_name3: Yup.string()
    .matches(
      /^(?=.*?[,()-])./,
      () => <FormattedMessage id="YUP_COMPANY_NAME_PATTERN" />,
    )
    .required(<FormattedMessage id="COMPANY_NAME_REQUIRED" />),
  company_name4: Yup.string()
    .trim(<FormattedMessage id="YUP.SPACE_NOT_ALLOWED" />)
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="YUP_ORGANIZATION_REQUIRED" />),
  company_contact_name: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="YUP_CONTACT_NAME" />),
  address: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(150, <FormattedMessage id="YUP.MAXIMUM_150" />)
    .required(<FormattedMessage id="YUP_ADRESS_REQUIRED" />),
  pincode: Yup.string().required(
    <FormattedMessage id="YUP_ZIPCODE_REQUIRED" />,
  ),
  state: Yup.string().required(<FormattedMessage id="YUP_STATE_REQUIRED" />),
  city: Yup.string().required(<FormattedMessage id="YUP_CITY_REQUIRED" />),
  country: Yup.string().required(
    <FormattedMessage id="YUP_COUNTRY_REQUIRED" />,
  ),
  title: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="GLOBAL.TILTE_REQUIRED_TEXT" />),
  role: Yup.string().required(<FormattedMessage id="YUP_ROLE_REQUIRED" />),
  loc_name: Yup.string().required(<FormattedMessage id="YUP_LOCATION_NAME" />),
  loc_type: Yup.string().required(<FormattedMessage id="YUP_LOCATION_TYPE" />),
  loc_street1: Yup.string()
    .required(<FormattedMessage id="YUP_STREET_REQUIRED" />)
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(150, <FormattedMessage id="YUP.MAXIMUM_150" />),
  loc_phone: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      () => <FormattedMessage id="YUP_VALID_NUMBER" />,
    )
    .min(10, <FormattedMessage id="YUP.MINIMUM_10" />)
    .max(11, <FormattedMessage id="YUP.MAXIMUM_11" />),
  location_notes: Yup.string().max(
    500,
    <FormattedMessage id="YUP.MAXIMUM_500" />,
  ),
  street2: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(150, <FormattedMessage id="YUP.MAXIMUM_150" />),
  category_name: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="CATEGORY.CATEGORY_VALIDATION_MSG" />),
  asset_class_id: Yup.string().required(
    <FormattedMessage id="CATEGORY.ASSET_CLASS_VALIDATION_MSG" />,
  ),
  category_id: Yup.string().required(
    <FormattedMessage id="YUP_CATEGORY_REQUIRED" />,
  ),
  description: Yup.string().required(
    <FormattedMessage id="YUP_DESCRIPTION_REQUIRED" />,
  ),
  is_location_native: Yup.string().required(
    <FormattedMessage id="YUP_ISLOADING_NATIVE_REQUIRED" />,
  ),
  location_type: Yup.string().required(
    <FormattedMessage id="YUP_LOCATION_TYPE_REQUIRED" />,
  ),
  location: Yup.string().when(
    "isLocationNative",
    (isLocationNative, schema) => {
      if (isLocationNative === "no") {
        return schema;
      } else {
        return schema.required(
          <FormattedMessage id="YUP_LOCATION_ID_REQUIRED" />,
        );
      }
    },
  ),
  aminite_value: Yup.array().min(1, <FormattedMessage id="YUP.MINIMUM_1" />),
  pickup_detail: Yup.string().max(
    1000,
    <FormattedMessage id="YUP.MAXIMUM_1000" />,
  ),
  is_loading_assistance_provided: Yup.string().required(
    <FormattedMessage id="YUP_LOADING_ASSISTANCE_REQUIRED" />,
  ),
  transport_type: Yup.string().required(
    <FormattedMessage id="FINANCE_PARTNER_REQUIRED" />,
  ),
  logistic_type: Yup.string().required(
    <FormattedMessage id="SERVICE_OFFERED_REQUIRED" />,
  ),
  other_type: Yup.string().when("otherTypeVal", (otherTypeVal, schema) => {
    return otherTypeVal
      ? Yup.string().required(<FormattedMessage id="GLOBAL.REQUIRED_TEXT" />)
      : Yup.string();
  }),
  other_service: Yup.string().when(
    "otherServiceVal",
    (otherServiceVal, schema) => {
      return otherServiceVal
        ? Yup.string().required(
          <FormattedMessage id="GLOBAL.REQUIRED_TEXT" />,
        )
        : Yup.string();
    },
  ),
  length: Yup.string()
    .matches(/^[0-9\b]+$/, () => <FormattedMessage id="YUP_DIGIT_ONLY" />)
    .min(1, <FormattedMessage id="YUP.MINIMUM_1" />)
    .max(11, <FormattedMessage id="YUP.MAXIMUM_11" />)
    .required(<FormattedMessage id="YUP_LENGTH_REQUIRED" />),
  width: Yup.string()
    .matches(/^[0-9\b]+$/, () => <FormattedMessage id="YUP_DIGIT_ONLY" />)
    .min(1, <FormattedMessage id="YUP.MINIMUM_1" />)
    .max(11, <FormattedMessage id="YUP.MAXIMUM_11" />)
    .required(<FormattedMessage id="YUP_WIDTH_REQUIRED" />),
  height: Yup.string()
    .matches(/^[0-9\b]+$/, () => <FormattedMessage id="YUP_DIGIT_ONLY" />)
    .min(1, <FormattedMessage id="YUP.MINIMUM_1" />)
    .max(11, <FormattedMessage id="YUP.MAXIMUM_11" />)
    .required(<FormattedMessage id="YUP_HEIGHT_REQUIRED" />),
  company_make_modal: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />),
  string: Yup.string(),
  time: Yup.string().required(<FormattedMessage id="GLOBAL.REQUIRED_TEXT" />),
  organization_name: Yup.string()
    .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
    .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
    .required(<FormattedMessage id="YUP_ORGANIZATION_NAME_REQUIRED" />),
};
